import { Component } from '@angular/core';

@Component({
  selector: 'app-psd-vertical-header',
  standalone: false,
  templateUrl: './psd-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class PsdVerticalHeaderComponent {


}
